import React, { createContext, useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { isLocalHost } from "../helpers/check-environment";
import extractRequiredFields from "../helpers/extract-required-fields";

interface YupContextProps {
  requiredFields: Record<string, boolean>;
}

const YupContext = createContext<YupContextProps | undefined>(undefined);

interface YupProviderProps {
  schema: Yup.ObjectSchema<any>;
  children: React.ReactNode;
  customerFieldsRequired?: Record<string, boolean>;
}

const YupProvider: React.FC<YupProviderProps> = ({ schema, children }) => {
  const [requiredFields, setRequiredFields] = useState<Record<string, boolean>>({});

  useEffect(() => {
    if (schema instanceof Yup.object) {
      const required = extractRequiredFields(schema);
      setRequiredFields(required);
    }
  }, [schema]);

  return (
    <YupContext.Provider value={{ requiredFields }}>{children}</YupContext.Provider>
  );
};

const useYupContext = (): YupContextProps => {
  const context = useContext(YupContext);
  if (!context) {
    if (isLocalHost()) {
    }
    return { requiredFields: {} };
  }

  return context;
};

export { YupProvider, useYupContext };
